import { BaseBoxShapeUtil, HTMLContainer, Rectangle2d, TLBaseShape, toDomPrecision } from 'tldraw';

type YearMarkerShape = TLBaseShape<
  'year-marker',
  {
    w: number;
    h: number;
    year: string;
  }
>;

export class YearMarkerNode extends BaseBoxShapeUtil<YearMarkerShape> {
  static override type = 'year-marker' as const;

  override getDefaultProps(): YearMarkerShape['props'] {
    return {
      w: 50,
      h: 40,
      year: '',
    };
  }

  override getGeometry(shape: YearMarkerShape) {
    return new Rectangle2d({
      width: shape.props.w,
      height: shape.props.h,
      isFilled: false,
    });
  }

  override component(shape: YearMarkerShape) {
    const { year } = shape.props;

    return (
      <HTMLContainer>
        <div
          style={{
            width: toDomPrecision(shape.props.w),
            height: toDomPrecision(shape.props.h),
          }}
          className="pointer-events-none flex items-center justify-center rounded-lg border border-gray-200 bg-white font-bold text-black shadow-md"
        >
          {year}
        </div>
      </HTMLContainer>
    );
  }

  override indicator(shape: YearMarkerShape) {
    return <rect width={shape.props.w} height={shape.props.h} />;
  }
}
